// @flow
import { List } from 'immutable';

import {
  mkInstitution,
  mkInstitutionFdsData,
  mkInstitutionFormField,
  mkInstitutionOfxData,
  mkInstitutionPartnerAuth,
  mkInstitutionPlaidData,
} from './types';

export const transformResponseToInstitutions = (data: any) => (
  data.map((institution) => transformApiDataToInstitution(institution))
);

export const transformResponseToInstitution = ({ data }: any) =>
  transformApiDataToInstitution(data);

export const transformSearchResponseToInstitutions = (response: any) =>
  List(response.data.map(({ id, name, url }) => mkInstitution({ id, name, url })));

// const transformApiDataToInstitutionWithLogging = (data: any) => {
//   console.log('Transforming API data to Institution', data);
//   return transformApiDataToInstitution(data);
// };

const transformApiDataToInstitution = (data: any) => (
  mkInstitution({
    id: data.id,
    name: data.name,
    url: data.url,

    primaryColor: data.primaryColor,
    accentColor: data.accentColor,
    accentTextColor: data.accentTextColor,
    logo: data.logo,
    logoUrl: data.logoUrl,

    ofx: data.ofx ? mkInstitutionOfxData({
      bid: data.ofx.bid,
      pid: data.ofx.pid,
      name: data.ofx.name,
      contact_url: data.ofx.contact ? data.ofx.contact.url : '',
      contact_phone: data.ofx.contact ? data.ofx.contact.phone : '',
      registraction_url: data.ofx.dcRegistrationUrl,
    }) : null,
    fds: data.fds ? mkInstitutionFdsData({
      id: data.fds.id,
      name: data.fds.name,

      contact_url: data.fds.contact ? data.fds.contact.url : '',
      contact_phone: data.fds.contact ? data.fds.contact.phone : '',
      contact_email: data.fds.contact ? data.fds.contact.email : '',

      login_url: data.fds.loginUrl,
      formFields: data.fds.form ? List(data.fds.form.fields.map((field) => (
        mkInstitutionFormField({
          key: field.cpId,
          name: field.name,
          type: field.type,
          displayOrder: field.displayOrder,
          displayLabel: field.displayLabel,
          helpText: field.helpText,
          maxLength: field.maxLength,
        })
      ))) : null,
      partnerAuth: data.fds.partnerAuth ? mkInstitutionPartnerAuth({
        intuitProperty: data.fds.partnerAuth.intuitProperty,
        offeringRedirectUri: data.fds.partnerAuth.offeringRedirectUri,
        partnerAuthUrl: data.fds.partnerAuth.partnerAuthUrl,
        partnerUid: data.fds.partnerAuth.partnerUid,
        fields: List(data.fds.partnerAuth.fields.map((field) => (
          mkInstitutionFormField({
            key: field.cpId,
            name: field.name,
            type: field.type,
            displayOrder: field.displayOrder,
            displayLabel: field.displayLabel,
            helpText: field.helpText,
            maxLength: field.maxLength,
          })
        ))),
      }) : null,
      ewcLive: data.fds ? data.fds.isEwcLive : false,
    }) : null,
    plaid: data.plaid ? mkInstitutionPlaidData({
      id: data.plaid.id,
      name: data.plaid.name,
    }) : null,
  })
);

